module.exports = __webpack_public_path__ + "pic6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic6.jpg
// module id = 1583
// module chunks = 4